var map = {
	"./1.png": 2994,
	"./123.png": 9851,
	"./3.png": 3312,
	"./33.png": 1513,
	"./4.png": 1967,
	"./and.png": 4144,
	"./back.png": 9202,
	"./d-bg-b.png": 7418,
	"./d-bg.png": 4567,
	"./d-bg1.png": 9790,
	"./d-bg2.png": 8565,
	"./download-en.png": 1763,
	"./download-hk-1.png": 9639,
	"./download-hk.png": 2293,
	"./download-vi.png": 3449,
	"./download.png": 2043,
	"./ic_hs_ks_market.png": 9315,
	"./ic_hs_ks_renwu.png": 1840,
	"./icon_huodong.png": 79,
	"./ios.png": 5612,
	"./jjsx-en.png": 9076,
	"./jjsx-hk.png": 8394,
	"./jjsx-vn.png": 8757,
	"./jjsx.png": 950,
	"./jjsx2.png": 2694,
	"./jjsx3.png": 6495,
	"./jjsx4.png": 8464,
	"./logo.png": 8494,
	"./money.png": 5823,
	"./more1.png": 2403,
	"./more2.png": 5544,
	"./more4.png": 6318,
	"./more_game1.png": 2522,
	"./my.png": 3709,
	"./pic_avator_01.png": 1111,
	"./pic_avator_02.png": 4076,
	"./pic_avator_03.png": 5701,
	"./pic_avator_04.png": 3642,
	"./pic_avator_05.png": 3475,
	"./pic_avator_06.png": 1496,
	"./qr_bg.png": 6942,
	"./qr_bg_en.png": 5522,
	"./qr_bg_hk.png": 160,
	"./qr_bg_vi.png": 8880,
	"./tip1.png": 159,
	"./tip2.png": 5668,
	"./tip3.png": 8701,
	"./tip4.png": 4450,
	"./tip5.png": 5579,
	"./tip6.png": 4288,
	"./tip7.png": 537,
	"./组 1 拷贝.png": 368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 848;